import type { SVGProps } from 'react';

export const ArrowDown = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.25 14.8V6a.71.71 0 0 1 .2-.525.748.748 0 0 1 .55-.225c.217 0 .392.075.525.225.15.133.225.308.225.525v8.8l3.325-3.325a.68.68 0 0 1 .5-.2.67.67 0 0 1 .55.2.72.72 0 0 1 .225.525.72.72 0 0 1-.225.525l-4.5 4.5A.862.862 0 0 1 12 17.3a.862.862 0 0 1-.625-.275l-4.5-4.5a.774.774 0 0 1-.225-.5c0-.217.075-.4.225-.55a.72.72 0 0 1 .525-.225c.2 0 .375.075.525.225L11.25 14.8Z" />
    </svg>
  );
};
